import { PlatformType, PlatformInfo } from '@root/config';
export class User {
  id: string;
  client_id: string;
  origin_customer_id: string;
  thirdparty_type: PlatformType;
  name: string;
  photo: string;

  constructor(options?: any) {
    this.id = options.id || '';
    this.client_id = options.client_id;
    this.origin_customer_id = options.origin_customer_id || '';
    this.thirdparty_type = options.thirdparty_type || PlatformType.Airbnb;
    this.name = options.name || '';
    this.photo = options.photo || '/assets/icon/icon_default_user.png';
  }

  get thirdparty_name() {
    return PlatformInfo[this.thirdparty_type] ? PlatformInfo[this.thirdparty_type].name : '';
  }

  get thirdparty_user_page() {
    return (
      PlatformInfo[this.thirdparty_type] &&
      PlatformInfo[this.thirdparty_type].user_page_url.replace(/@@@@/, this.origin_customer_id)
    );
  }
}
